export const POLICY_STATE_REASON = {
  renewalNotAccepted: "300",
};
